import Typography from 'typography'

const typography = new Typography({
  baseFontSize: '16px',
  baseLineHeight: 2.2,
  headerLineHeight: 1.3,
  scaleRatio: 2.4,
  headerFontFamily: [
    'FFMark',
    '-apple-system',
    'BlinkMacSystemFont',
    'Segoe UI',
    'Roboto',
    'Oxygen',
    'Ubuntu',
    'Cantarell',
    'Fira Sans',
    'Droid Sans',
    'Helvetica Neue',
    'sans-serif'
  ],
  bodyFontFamily: [
    'FFMark',
    '-apple-system',
    'BlinkMacSystemFont',
    'Segoe UI',
    'Roboto',
    'Oxygen',
    'Ubuntu',
    'Cantarell',
    'Fira Sans',
    'Droid Sans',
    'Helvetica Neue',
    'sans-serif'
  ],
  headerWeight: '600',
  bodyWeight: '400',
  includeNormalize: true,
  bodyColor: '#424C5E'
})

export default typography
